<template>
    <users></users>
</template>

<script>
import Users from '@/components/Users/UsersHome';

export default {
    name: 'UsersView',
    components: {
        Users
    }
};
</script>

<style></style>
